/* eslint-disable max-len */
import 'react';

const SettingWarnSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_32094_31624" style={{'maskType': 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
            <rect width="18" height="18" fill="black" />
        </mask>
        <g mask="url(#mask0_32094_31624)">
            <path d="M9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75Z" fill="#3377FF" />
            <path d="M9 7.78125V12" stroke="white" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 5.25C9.31066 5.25 9.5625 5.50184 9.5625 5.8125C9.5625 6.12316 9.31066 6.375 9 6.375C8.68934 6.375 8.4375 6.12316 8.4375 5.8125C8.4375 5.50184 8.68934 5.25 9 5.25Z" fill="white" />
        </g>
    </svg>

);
export default SettingWarnSvg;

